module.exports = __webpack_public_path__ + "img/odeko_logo_black.11006353.png";